<template>
  <div class="d-flex">
    <v-select
      v-model="relatorio_selecionado"
      :items="itens"
      outlined
      dense
      dark
      hide-details
      item-value="id_aplicativo"
      item-text="descricao_aplicativo"
      label="Selecione um relatório"
      :loading="carregando_dados"
      style="max-width: 18em"
    />

    <v-btn color="success" class="ml-3" @click="gerarRelatorio()" v-text="'Gerar'" :disabled="!cotacao.id_cotacao"/>
  </div>
</template>

<script>
import $axios from "@/api/api";
import { mapGetters } from 'vuex';

export default {
  props: {
    pedido: {
      type: Object,
      required: true
    },
    cotacao: {
      type: Object,
      default: () => { return {id_cotacao: null} }
    }
  },
  data() {
    return {
      relatorio_selecionado: 1,
      itens: [
        { id_aplicativo: 1, url: 'pdf', descricao_aplicativo: 'Relatorio Cotação PDF' },
        { id_aplicativo: 2, url: 'excel', descricao_aplicativo: 'Relatorio Cotação Excel' }
      ],
      carregando_dados: false
    }
  },
  computed: {
    ...mapGetters({
      grupo_compra: "usuario/getGrupoCompras"
    })
  },
  methods: {
    gerarRelatorio () {
      if (!(this.pedido.idpedido > 0) || !this.cotacao.id_cotacao) return;

      const idx_relatorio = this.itens.findIndex((el) => el.id_aplicativo == this.relatorio_selecionado);
      const url = `${$axios.defaults.baseURL}/relatorios/compra/cotacao/${this.itens[idx_relatorio].url}/${this.pedido.idpedido}/${this.cotacao.id_cotacao}/${this.grupo_compra}/${localStorage.nome}`;

      window.open(url, "_blank");
    },
  }
}
</script>

<style>

</style>
